/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateTaxonomyDto { 
    _id: string;
    name: string;
    categoryName: string;
    linkableArray?: Array<string>;
    removedFlag?: boolean;
    customFields?: object;
}

